export const getCountryLabel = (
  countryCode: null | string | undefined,
  countryName: string
): string => (countryCode === 'TW' ? 'Chinese Taiwan' : countryName);
